import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ErrorHandlerService } from '../error-handler.service';

@Component({
  selector: 'app-callback-auth',
  template: `<p>Processando login...</p>`
})
export class CallbackAuthComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private errorHandler: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.loginCallback(params['code']);
    });
  }

    loginCallback(authcode: string) {

    this.auth.loginCallback(authcode)
      .then(response => {
        if (response) {
          this.router.navigate(['paineis']).then(() => {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          });
        }
      })
      .catch(erro => {
        console.log(erro);
        this.errorHandler.handle(erro);
      });
  }
}
